module.exports = __webpack_public_path__ + "static/media/m-aquacare.10723a25.pdf";